import { render } from "./search-result-item.vue?vue&type=template&id=0b30aba0&ts=true"
import script from "./search-result-item.ts?vue&type=script&lang=ts&external"
export * from "./search-result-item.ts?vue&type=script&lang=ts&external"

import "./search-result-item.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__